import React, { useState, useEffect, useRef } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { useDialog } from "react-st-modal";
import { styled } from "@mui/material/styles";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import NotificationSystem from "react-notification-system";
import AlertResponse from "../../main_components/alerts/alertResponse";
import { catchErrorModul } from "../../main_components/catchErr/catchError";
import { get_brands, get_models, post_vehicle } from "../../services/assets/assets";
import { refresh_token } from "../../main_components/tokens/tokenrefresh";
import { get_route } from "../../services/configuration/configuration";
import { get_employess } from "../../services/humanResources/humanResources";
import dataconfv from "../../dataComponets/configure_vehicule.json";

const ValidationTextField = styled(TextField)({
  "& input:valid + fieldset": { borderColor: "black", borderWidth: 1 },
  "& input:valid:focus + fieldset": {
    borderLeftWidth: 6,
    padding: "4px !important",
  },
});
const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(6px)",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(22px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;base64,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')`,
      },
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#8796A5" : "#aab4be",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: theme.palette.mode === "dark" ? "white" : "white",
    width: 32,
    height: 32,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundImage: `url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjBweCIgeT0iMHB4Igp3aWR0aD0iMjAiIGhlaWdodD0iMjAiCnZpZXdCb3g9IjAgMCA1MCA1MCIKc3R5bGU9ImZpbGw6IzQwQzA1NzsiPgo8cGF0aCBkPSJNIDIyLjc4MTI1IDAgQyAyMS42MDU0NjkgLTAuMDAzOTA2MjUgMjAuNDA2MjUgMC4xNjQwNjMgMTkuMjE4NzUgMC41MzEyNSBDIDEyLjkwMjM0NCAyLjQ5MjE4OCA5LjI4OTA2MyA5LjI2OTUzMSAxMS4yNSAxNS41OTM3NSBMIDExLjI1IDE1LjY1NjI1IEMgMTEuNTA3ODEzIDE2LjM2NzE4OCAxMi4xOTkyMTkgMTguNjE3MTg4IDEyLjYyNSAyMCBMIDkgMjAgQyA3LjMwMDc4MSAyMCA2IDIxLjMwMDc4MSA2IDIzIEwgNiA0NyBDIDYgNDguNjk5MjE5IDcuMzAwNzgxIDUwIDkgNTAgTCA0MSA1MCBDIDQyLjY5OTIxOSA1MCA0NCA0OC42OTkyMTkgNDQgNDcgTCA0NCAyMyBDIDQ0IDIxLjMwMDc4MSA0Mi42OTkyMTkgMjAgNDEgMjAgTCAxNC43NSAyMCBDIDE0LjQ0MTQwNiAxOS4wMDc4MTMgMTMuNTExNzE5IDE2LjA3NDIxOSAxMy4xMjUgMTUgTCAxMy4xNTYyNSAxNSBDIDExLjUxOTUzMSA5LjcyMjY1NiAxNC41IDQuMTA5Mzc1IDE5Ljc4MTI1IDIuNDY4NzUgQyAyNS4wNTA3ODEgMC44MzIwMzEgMzAuNjk1MzEzIDMuNzk2ODc1IDMyLjM0Mzc1IDkuMDYyNSBDIDMyLjM0Mzc1IDkuMDY2NDA2IDMyLjM0Mzc1IDkuMDg5ODQ0IDMyLjM0Mzc1IDkuMDkzNzUgQyAzMi41NzAzMTMgOS44ODY3MTkgMzMuNjU2MjUgMTMuNDA2MjUgMzMuNjU2MjUgMTMuNDA2MjUgQyAzMy43NDYwOTQgMTMuNzY1NjI1IDM0LjAyNzM0NCAxNC4wNTA3ODEgMzQuMzg2NzE5IDE0LjEzNjcxOSBDIDM0Ljc1IDE0LjIyNjU2MyAzNS4xMjg5MDYgMTQuMTA5Mzc1IDM1LjM3NSAxMy44MzIwMzEgQyAzNS42MjEwOTQgMTMuNTUwNzgxIDM1LjY5NTMxMyAxMy4xNjAxNTYgMzUuNTYyNSAxMi44MTI1IEMgMzUuNTYyNSAxMi44MTI1IDM0LjQzMzU5NCA5LjE3MTg3NSAzNC4yNSA4LjUzMTI1IEwgMzQuMjUgOC41IEMgMzIuNzgxMjUgMy43NjE3MTkgMjguNjAxNTYzIDAuNTQyOTY5IDIzLjkzNzUgMC4wNjI1IEMgMjMuNTUwNzgxIDAuMDIzNDM3NSAyMy4xNzE4NzUgMCAyMi43ODEyNSAwIFogTSAyNSAzMCBDIDI2LjY5OTIxOSAzMCAyOCAzMS4zMDA3ODEgMjggMzMgQyAyOCAzMy44OTg0MzggMjcuNjAxNTYzIDM0LjY4NzUgMjcgMzUuMTg3NSBMIDI3IDM4IEMgMjcgMzkuMTAxNTYzIDI2LjEwMTU2MyA0MCAyNSA0MCBDIDIzLjg5ODQzOCA0MCAyMyAzOS4xMDE1NjMgMjMgMzggTCAyMyAzNS4xODc1IEMgMjIuMzk4NDM4IDM0LjY4NzUgMjIgMzMuODk4NDM4IDIyIDMzIEMgMjIgMzEuMzAwNzgxIDIzLjMwMDc4MSAzMCAyNSAzMCBaIj48L3BhdGg+Cjwvc3ZnPg==')`,
    },
  },
  "& .MuiSwitch-track": {
    backgroundColor: theme.palette.mode === "dark" ? "white" : "white",
    borderRadius: 20 / 2,
  },
}));

const Set_vehicle = () => {
  //Vehiculo
  const [vehicular_config, setvehicular_config] = React.useState("VL");
  const [license_plate, setlicense_plate] = React.useState("");
  const [year_model, setyear_model] = React.useState("");
  const [asegura_resp_civil, setasegura_resp_civil] = React.useState("");
  const [poliza_resp_civil, setpoliza_resp_civil] = React.useState("");
  const [id_model_fk, setid_model_fk] = React.useState(909999909);
  const [description, setdescription] = React.useState("");
  const [asegura_med_ambiente, setasegura_med_ambiente] = React.useState("");
  const [poliza_med_ambiente, setpoliza_med_ambiente] = React.useState("");
  const [asegura_carga, setasegura_carga] = React.useState("");
  const [poliza_carga, setpoliza_carga] = React.useState("");
  const [prima_seguro, setprima_seguro] = React.useState("");
  const [id_route_fk, setid_route_fk] = React.useState(1);
  const [brands, setbrands] = useState([]);

  //fin

  const [type, settype] = React.useState("");
  const [license_num, setlicense_num] = React.useState("");
  const [num_reg_id_trib, setnum_reg_id_trib] = React.useState("");
  const [fiscal_residence, setfiscal_residence] = React.useState("");
  const [transport_parts, settransport_parts] = React.useState("");
  const [id_employee_fk, setid_employee_fk] = React.useState("");
  const dialog = useDialog();
  const [modalT, setmodalT] = useState(false);
  const [routes, setroutes] = useState([]);
  const [employeesP, setemployeesP] = useState([]);
  const [models, setmodels] = useState([]);

  const [checkedGeneral, setcheckedGeneral] = React.useState(true);
  const [isvalidad, setisvalidad] = React.useState(false);

  const [Busnes, setBusnes] = React.useState();
  const [brandsselect, setbrandsselect] = React.useState();

  const [Busnesrfc, setBusnesrfc] = React.useState();

  const notificationSystemRef = useRef();

  const handlevehicular_config = (event) => {
    setvehicular_config(event.target.value);
  };
  const handlelicense_plate = (event) => {
    setlicense_plate(event.target.value);
  };

  const handleyear_model = (event) => {
    setyear_model(event.target.value);
  };

  const handlepoliza_med_ambiente = (event) => {
    setpoliza_med_ambiente(event.target.value);
  };

  const handleasegura_med_ambient = (event) => {
    setasegura_med_ambiente(event.target.value);
  };
  const handleasegura_carga = (event) => {
    setasegura_carga(event.target.value);
  };

  const handleasegura_resp_civil = (event) => {
    setasegura_resp_civil(event.target.value);
  };

  const handlepoliza_resp_civil = (event) => {
    setpoliza_resp_civil(event.target.value);
  };

  const handledescription = (event) => {
    setdescription(event.target.value);
  };

  const handlepoliza_carga = (event) => {
    setpoliza_carga(event.target.value);
  };

  const handleprima_seguro = (event) => {
    setprima_seguro(event.target.value);
  };

  const handlelicense_num = (event) => {
    setlicense_num(event.target.value.toUpperCase());
  };
  const handlenum_reg_id_trib = (event) => {
    setnum_reg_id_trib(event.target.value.toUpperCase());
  };
  const handlefiscal_residence = (event) => {
    setfiscal_residence(event.target.value.toUpperCase());
  };
  const handletransport_parts = (event) => {
    settransport_parts(event.target.value.toUpperCase());
  };
  const handleid_employee_fk = (event) => {
    setid_employee_fk(event.target.value.toUpperCase());
  };
  const handleid_route_fk = (event) => {
    setid_route_fk(event.target.value.toUpperCase());
  };

  const handleid_models_fk = (event) => {
    setid_model_fk(event.target.value);
  };
  const handlechecked = (event) => {
    setcheckedGeneral(event.target.checked);
    console.log(event.target.checked);
  };

  const handleOnSearch = (string, results) => {};

  const handleOnHover = (result) => {};

  const handleOnSelect = (item) => {
    handlemodels(item.id);
  };

  const handleOnFocus = () => {
    console.log("Focused");
  };

  const handleOnClear = () => {
    console.log("Cleared");
  };

  var data1 = {
    vehicle: {
      vehicular_config: vehicular_config, //por defecto

      license_plate: license_plate,

      year_model: year_model,

      asegura_resp_civil: asegura_resp_civil,

      poliza_resp_civil: poliza_resp_civil,

      id_model_fk: id_model_fk,

      description: description,

      asegura_med_ambiente: asegura_med_ambiente, //Opcionales

      poliza_med_ambiente: poliza_med_ambiente, //Opcionales

      asegura_carga: asegura_carga, //Opcionales

      poliza_carga: poliza_carga, //Opcionales

      prima_seguro: prima_seguro, //Opcionales

      id_route_fk: id_route_fk, //Opcionales
    },
  };

  console.log(data1);

  
  async function handleSubmit(event) {
    
    if(id_model_fk===909999909||id_model_fk==="909999909"){
     
      notificationSystemRef.current.addNotification({
            message: (
              <AlertResponse
                msj={"Falta asignar modelo"}
                view={false}
              ></AlertResponse>
            ),
            level: "error",
            position: "br",
            autoDismiss: 60,
          });
      return null;
    }
    

    event.preventDefault();    
    setmodalT(true);
    var data = {
      vehicle: {
        vehicular_config: vehicular_config, //por defecto
  
        license_plate: license_plate,
  
        year_model: parseInt(year_model),
  
        asegura_resp_civil: asegura_resp_civil,
  
        poliza_resp_civil: poliza_resp_civil,
  
        id_model_fk:id_model_fk===909999909||id_model_fk==="909999909"?null: parseInt(id_model_fk),
  
        description: description,
  
        asegura_med_ambiente: checkedGeneral===true?null: asegura_med_ambiente===""?null:asegura_med_ambiente, //Opcionales
  
        poliza_med_ambiente: checkedGeneral===true?null: poliza_med_ambiente===""?null:poliza_med_ambiente, //Opcionales
  
        asegura_carga: checkedGeneral===true?null: asegura_carga===""?null:asegura_carga, //Opcionales
  
        poliza_carga: checkedGeneral===true?null: poliza_carga===""?null:poliza_carga, //Opcionales
  
        prima_seguro: checkedGeneral===true?null: prima_seguro===""?null:prima_seguro, //Opcionales
  
        id_route_fk: checkedGeneral===true?null: parseInt(id_route_fk), //Opcionales
      },
    };

    var jsonMandar=data;

    try{
      var rf_token = await refresh_token();
      if(rf_token===true){
        setTimeout(async() => {
          try{
            const d = await post_vehicle(data);
            console.log("RESPONSE RECEIVED: ", d);
            setmodalT(false);
            dialog.close(true);
          }catch(err){
            console.log(err?.response)
            catchErrorModul("Vehículos",JSON.stringify(jsonMandar),JSON.stringify(err?.response===undefined?"Token expirado":err?.response));
            var errroM = err?.response?.data?.errorMessage;
            notificationSystemRef.current.addNotification({
              message: (
                <AlertResponse
                  msj={
                    errroM === undefined
                      ? "Error 401:No autorizado intentelo nuevamente o recarge la pagina nuevamente oprimiendo la tecla 'CTRL + F5'"
                      : errroM
                  }
                  view={false}
                ></AlertResponse>
              ),
              level: "error",
              position: "br",
              autoDismiss: 60,
            });
            setmodalT(false);
          }
        }, 1000);
      }else{}
    }catch(err){
      console.log(err);
    }
  }

  const handlerute = async(event) => {
    event?.preventDefault();
    try {
      var rf_token = await refresh_token();
      if(rf_token===true){
        setTimeout(async() => {
          try{
            var d = await get_route();
            setroutes(d === null ? [] : d.data.routes);  
          }catch(err){
            console.log(err);
            setroutes([]);
          }
        }, 1000);
      }else{}
    } catch (err) {
      console.log(err);
    }
  };

  const handlebrands = async (event) => {
    event?.preventDefault();
    try{
      var rf_token = await refresh_token();
      if(rf_token===true){
        setTimeout(async() => {
          try{
            const d = await get_brands();
            const data = d === null? [] : d.data.brands;
            const newdata= data.filter((d)=>d.type==="VEHÍCULO");
            const ndata = newdata.map((d) => {
              const json = {
                id: d.id,
                "name-type": d.name + "-" + d.type,
              };
              return json;
            });
            setbrands(ndata);
          }catch(err){
            setbrands([]);
          }
        }, 1000);
      }else{}
    }catch(err){
      console.log(err);
    }
  };

  const handlemodels = async(id_brands) => {
    try{
      var rf_token = await refresh_token();
      if(rf_token===true){
        setTimeout(async() => {
          try{
            const d = await get_models(id_brands);
            const data = d===null?[]:d.data.models;
            const data2 = {
              id: 909999909,
              name: "Selecciona una marca",
              id_company_fk: 0,
              date_register: "0",
            };
            const ndata = data.concat(data2);
            console.log(ndata);
            setmodels(ndata);
          }catch(err){
            setmodels([]);
          }
        }, 1000);
      }else{}
    }catch(err){  
      console.log(err);
    }

  };

  const handleEmployees = async(event) => {
    event?.preventDefault();
    try{
      var rf_token=await refresh_token();
      if(rf_token===true){
        setTimeout(async() => {
          try{
            const d = await get_employess();
            const data = d===null?[]:d.data;
            const nEmployes = data.map((num, index) => {
              var ndata = {
                fullname:
                  num?.name +
                  " " +
                  num?.first_last_name +
                  " " +
                  num?.second_last_name,
                id: num.id,
                rfc: num.rfc,
              };
              return ndata;
            });
            console.log(nEmployes);
            setemployeesP(nEmployes);
          }catch(err){
            setemployeesP([]);
          }
        }, 1000);
      }else{}
    }catch(err){
      console.log(err);
    }
  };

  useEffect(() => {
    handlerute();
    handleEmployees();
    handlebrands();
  }, []);

  return (
    <div className="">
      <NotificationSystem ref={notificationSystemRef} />

      <br></br>
      <div>
        <div className="containerVehicles">
          <div className="bp-1">
          <TextField
              select
             
              label="Configuración Vehicular"
              value={vehicular_config}
              sx={{ m: 1.5, width: "100%" }}
              onChange={handlevehicular_config}
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              SelectProps={{
                native: true,
              }}
            >
              {dataconfv?.map((option) => (
                <option key={option.value} value={option.value} title={option.label}>
                  {option.value}
                </option>
              ))}
            </TextField>


            {/* <ValidationTextField
              label="Configuración Vehicular"
              required
              placeholder="Configuración Vehicular"
              inputProps={{ maxLength: 5 }}
              sx={{ m: 2, width: "100%" }}
              variant="outlined"
              value={vehicular_config}
              onChange={handlevehicular_config}
              InputLabelProps={{
                shrink: true,
              }}
            /> */}
          </div>
          <div className="bp-7">
            <ValidationTextField
              label="Placa"
              required
              placeholder="Placa"
              sx={{ m: 2, width: "100%" }}
              inputProps={{ maxLength: 7 }}
              variant="outlined"
              value={license_plate}
              onChange={handlelicense_plate}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>

          <div className="bp-11">
            <ValidationTextField
              label="Asegura_Resp_Civil"
              required
              placeholder="Asegura_Resp_Civil"
              inputProps={{ maxLength: 50 }}
              sx={{ m: 2, width: "100%" }}
              variant="outlined"
              value={asegura_resp_civil}
              onChange={handleasegura_resp_civil}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>

          <div className="bp-12">
            <ValidationTextField
              label="Poliza_Resp_Civil"
              required
              placeholder="Poliza_Resp_Civil"
              inputProps={{ maxLength: 30 }}
              sx={{ m: 2, width: "100%" }}
              variant="outlined"
              value={poliza_resp_civil}
              onChange={handlepoliza_resp_civil}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>

          <div className="bp-13">
            <ValidationTextField
              label="Descripcción"
              placeholder="Descripcción"
              inputProps={{ maxLength: 254 }}
              sx={{ m: 2, width: "100%" }}
              variant="outlined"
              value={description}
              onChange={handledescription}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>

         

          <div className="bp-5-1">
            <ReactSearchAutocomplete
              items={brands}
              fuseOptions={{ keys: ["name-type"] }}
              resultStringKeyName="name-type"
              onSearch={handleOnSearch}
              onHover={handleOnHover}
              onSelect={handleOnSelect}
              onFocus={handleOnFocus}
              onClear={handleOnClear}
              showIcon={true}
              placeholder="Buscar Marcas..."
              styling={{
                height: "34px",
                border: "1px solid darkgreen",
                borderRadius: "4px",
                backgroundColor: "white",
                boxShadow: "none",
                hoverBackgroundColor: "lightgreen",
                color: "black",
                iconColor: "black",
                lineColor: "black",
                placeholderColor: "black",
                clearIconMargin: "3px 8px 0 0",
                zIndex: 10,
                position: "fixed",
              }}
            />
          </div>

          <div className="bp-6">
            <TextField
              select
              child
              label="Modelos"
              value={id_model_fk}
              sx={{ m: 1.5, width: "100%" }}
              onChange={handleid_models_fk}
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              SelectProps={{
                native: true,
              }}
            >
              {models?.map((option) => (
                <option key={option.id} value={option.id} selected={option.id}>
                  {option.name}
                </option>
              ))}
            </TextField>
          </div>

          <div className="bp-8">
            <FormControlLabel
              control={
                <MaterialUISwitch
                  sx={{ m: 1 }}
                  onChange={handlechecked}
                  checked={checkedGeneral}
                />
              }
              label={
                checkedGeneral === true ? "Datos extra" : "Ocultar datos extra"
              }
            />
          </div>

          <div
            className="bp-9"
            style={{ display: checkedGeneral === true ? "none" : "" }}
          >
            <TextField
              select
              child
              label="Ruta"
              value={id_route_fk}
              sx={{ m: 1.5, width: "100%" }}
              onChange={handleid_route_fk}
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              SelectProps={{
                native: true,
              }}
            >
              {routes?.map((option) => (
                <option key={option.id} value={option.id} selected={option.id}>
                  {option.route}
                </option>
              ))}
            </TextField>
          </div>

          <div className="bp-10">
            <ValidationTextField
              label="Año del modelo"
              required
              placeholder="Año del modelo"
              inputProps={{ maxLength: 5 }}
              sx={{ m: 2, width: "100%" }}
              variant="outlined"
              value={year_model}
              onChange={handleyear_model}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>

          

          <div
            className="bp-14"
            style={{ display: checkedGeneral === true ? "none" : "" }}
          >
            <ValidationTextField
              label="Aseguradora Medio Ambiente"
              placeholder="Aseguradora Medio Ambiente"
              inputProps={{ maxLength: 50 }}
              sx={{ m: 2, width: "100%" }}
              variant="outlined"
              value={asegura_med_ambiente}
              onChange={handleasegura_med_ambient}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>

          <div
            className="bp-15"
            style={{ display: checkedGeneral === true ? "none" : "" }}
          >
            <ValidationTextField
              label="Poliza Medio Ambiente"
              placeholder="Poliza Medio Ambiente"
              inputProps={{ maxLength: 30 }}
              sx={{ m: 2, width: "100%" }}
              variant="outlined"
              value={poliza_med_ambiente}
              onChange={handlepoliza_med_ambiente}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>

          <div
            className="bp-2"
            style={{ display: checkedGeneral === true ? "none" : "" }}
          >
            <ValidationTextField
              label="POliza de Carga "
              placeholder="Poliza de Carga"
              sx={{ m: 2, width: "100%" }}
              variant="outlined"
              inputProps={{ maxLength: 30 }}
              value={poliza_carga}
              onChange={handlepoliza_carga}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div
            className="bp-3"
            style={{ display: checkedGeneral === true ? "none" : "" }}
          >
            <ValidationTextField
              label="Prima de Seguro "
              placeholder="Prima de Seguro"
              sx={{ m: 2, width: "100%" }}
              type="number"
              variant="outlined"
              value={prima_seguro}
              onChange={handleprima_seguro}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>

          <div
            className="bp-4"
            style={{ display: checkedGeneral === true ? "none" : "" }}
          >
            <ValidationTextField
              label="Aseguradora de Carga "
              placeholder="Aseguradora de Carga"
              sx={{ m: 2, width: "100%" }}
              variant="outlined"
              inputProps={{ maxLength: 50 }}
              value={asegura_carga}
              onChange={handleasegura_carga}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>

          <div className="bp-21">
            <Button
              onClick={handleSubmit}
              sx={{ m: 2, width: "100%" }}
              variant="contained"
              style={{ background: "green" }}
            >
              Crear
            </Button>
          </div>

          <div className="bp-22">
            <Button
              onClick={() => {
                dialog.close();
              }}
              sx={{ m: 2, width: "100%" }}
              variant="contained"
              style={{ background: "red" }}
            >
              CANCELAR
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Set_vehicle;
